import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-207c703e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "D-Flex" }
const _hoisted_4 = { class: "DialogBody D-Flex" }
const _hoisted_5 = { class: "CookiesRow F-C2" }
const _hoisted_6 = {
  key: 0,
  class: "CookiesRow F1_25em"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "CookiesRow W-100 F1_25em"
}
const _hoisted_9 = { class: "CookiesRow P1em" }
const _hoisted_10 = {
  class: "M-Auto CookiesButton Rad3 BG2 Shadow1 Color3 HoverGlow",
  style: {"padding":"0.5em 1em"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_12 = { class: "M-Auto F-Bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesTabs = _resolveComponent("CookiesTabs")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CookiesTabs, {
          Res: 'D_Integration_WhatsappMessage_Tab',
          Tabs: _ctx.Tabs,
          Router: false,
          Default: _ctx.Tabs[0]
        }, null, 8, ["Tabs", "Default"])
      ]),
      _createVNode(_component_CookiesIcon, {
        ID: ('Whatsapp' as IconsIDs),
        style: {"width":"3.5em","height":"3.5em","padding":"1.5em"},
        class: "M-Auto Shadow1"
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.MEMRead('D_Integration_WhatsappMessage_Tab') && _ctx.MEMRead('D_Integration_WhatsappMessage_Tab').Value === 'Single')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_CookiesNormalInput, {
                  Placeholder: _ctx.Translate('Type a Phone Number'),
                  Res: 'D_Integration_WhatsappMessage_PhoneNumber'
                }, null, 8, ["Placeholder"]),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_ctx.MEMRead('D_Integration_WhatsappMessage_Tab') && _ctx.MEMRead('D_Integration_WhatsappMessage_Tab').Value === 'Multiple')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.Translate('Choose CSV file')) + " ", 1),
                    _createElementVNode("input", {
                      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ParseCSV())),
                      style: {"width":"0","height":"0","display":"none"},
                      type: "file",
                      accept: ".csv"
                    }, null, 32)
                  ])
                ]),
                (_ctx.CSVLoaded)
                  ? (_openBlock(), _createBlock(_component_CookiesTable, {
                      key: 0,
                      CookiesData: _ctx.Contacts,
                      TableSettings: _ctx.TableSettings
                    }, null, 8, ["CookiesData", "TableSettings"]))
                  : _createCommentVNode("", true),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
              style: _normalizeStyle('background: ' + _ctx.Theme.Shade3),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 5),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SendMessages())),
              class: _normalizeClass(["F-Bold CookiesButton DialogFooterButton BGMain", (_ctx.MEMRead('D_Integration_WhatsappMessage_Tab') && _ctx.MEMRead('D_Integration_WhatsappMessage_Tab').Value === 'Single' && _ctx.NumberValidity(_ctx.MEMRead('D_Integration_WhatsappMessage_PhoneNumber')) || (_ctx.MEMRead('D_Integration_WhatsappMessage_Tab') && _ctx.MEMRead('D_Integration_WhatsappMessage_Tab').Value === 'Multiple' && _ctx.Contacts.length > 0)) ? '' : 'Disabled'])
            }, _toDisplayString(_ctx.Translate('Send Message')), 3)
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}